// Webpack Imports
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es';

let calendar, swiperMonths, swiperAbout;
(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});


    // Initialize FullCalendar
    const calendarEl = document.querySelector('.wa-events-calendar-container');
    const swiperEl = document.querySelector('.wa-events-swiper-container');

    if (calendarEl && typeof wa_ranchito_data !== 'undefined' && wa_ranchito_data.events) {
        // Get current Events
        getEventsByMonth(0, 0);

        calendar = new Calendar(calendarEl, {
            plugins: [ dayGridPlugin ],
            initialView: 'dayGridMonth',
            locale: esLocale,
            events: wa_ranchito_data.events,
            headerToolbar: {
                right: ''
            },
            dayCellDidMount: function(info) {
                const events = calendar.getEvents();
                const hasEvent = events.some(event => {
                    return event.startStr === info.date.toISOString().split('T')[0];
                });

                if (hasEvent) {
                    info.el.classList.add('highlight-day-with-event');
                }
            },
            eventClick: function(info) {
                info.jsEvent.preventDefault();
                const id = info.event.id;
                abrirMiModalPersonalizado(id);
            }
        });
    }

    window.showEventsGrid = function(){
        swiperEl.classList.remove('d-none');
        swiperEl.classList.add('d-block');
        calendarEl.classList.add('d-none');
        document.querySelector('.grid_btn').classList.add('active');
        document.querySelector('.calendar_btn').classList.remove('active');
    }

    window.showEventsCalendar = function(){
        swiperEl.classList.add('d-none');
        calendarEl.classList.remove('d-none');
        calendarEl.classList.add('d-block');
        document.querySelector('.grid_btn').classList.remove('active');
        document.querySelector('.calendar_btn').classList.add('active');
        calendar.render();
        let _month = swiperMonths.slides[swiperMonths.activeIndex].dataset.month;
        let _year = swiperMonths.slides[swiperMonths.activeIndex].dataset.year;
        calendar.gotoDate( new Date(_year, _month - 1, 1) );
    }

    if(document.querySelector('.swiper-months')) {
        swiperMonths = new Swiper('.swiper-months', {
            slidesPerView: 3,
            centeredSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 5,
                },
                480: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
                320: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                }
            },
            modules: [Navigation],
            navigation: {
                nextEl: "#swiper-months-next",
                prevEl: "#swiper-months-prev",
            },
            on: {
                slideChange: function () {
                    const month = this.slides[this.activeIndex].dataset.month;
                    const year = this.slides[this.activeIndex].dataset.year;
                    getEventsByMonth(month, year);
                    calendar.gotoDate( new Date(year, month - 1, 1) );
                }
            }
        });

        swiperMonths.slideTo(1);
    }

    if(document.querySelector('.aboutSwiper')) {
        swiperAbout = new Swiper('.aboutSwiper', {
            slidesPerView: 1,
            autoplay: {
                delay: 10000,
                disableOnInteraction: true,
            },
            spaceBetween: 0,
            modules: [Pagination, Autoplay],
            pagination: {
                el: ".swiper-pagination-about",
                clickable: true,
            },
        });
    }


    const menuItems = document.querySelectorAll('.menu-class.menu_modal.modal_top li a');

    // Obtener el ítem de menú seleccionado guardado en LocalStorage
    const selectedMenuItem = localStorage.getItem('selectedMenuItem');

    // Si hay un ítem de menú seleccionado guardado, agregarle la clase 'selected'
    if (selectedMenuItem) {
        document.querySelector(`.menu-class.menu_modal.modal_top li a[href="${selectedMenuItem}"]`).classList.add('selected');
    }

    menuItems.forEach(function(item) {
        item.addEventListener('click', function() {
            // Remover la clase 'selected' de todos los elementos del menú
            menuItems.forEach(function(el) {
                el.classList.remove('selected');
            });

            // Agregar la clase 'selected' al elemento del menú actual
            this.classList.add('selected');

            // Guardar el ítem de menú seleccionado en LocalStorage
            localStorage.setItem('selectedMenuItem', this.getAttribute('href'));
        });
    });



})();


// Función para abrir el modal personalizado
let modalEvento = new bootstrap.Modal(document.getElementById('eventoModal'));
window.abrirMiModalPersonalizado = function(id) {

    $.ajax({
        url: wa_ranchito_data.ajaxurl,
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'get_event_content',
            id: id
        },
        success: function(response) {
            document.getElementById('modalTitulo').innerText = response.title;
            document.getElementById('modalCuerpo').innerHTML = response.content;
            modalEvento.show();
        }
    });

}

function getEventsByMonth(month, year){
    $.ajax({
        url: wa_ranchito_data.ajaxurl,
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'get_events_by_month',
            month: month,
            year: year
        },
        beforeSend: function() {
            document.getElementById('wa-events-month-items').innerHTML = '';
            document.getElementById('wa-events-month-items').classList.add('loading');
        },
        complete: function() {
            document.getElementById('wa-events-month-items').classList.remove('loading');
        },
        success: function(response) {
            document.getElementById('wa-events-month-items').innerHTML = response.content;
        },
        error: function(response) {
            document.getElementById('wa-events-month-items').innerHTML = '';
        }
    });
}

window.getEventsByMonth = function(month, year){
    getEventsByMonth(month, year);
}

window.openModalForm = function(modalId, eventId) {
    // 1. Obtener el modal
    const modalEl = document.getElementById(modalId);
    if (!modalEl) return;

    modalEvento.hide();
    // 2. Mostrar el modal
    const modal = new bootstrap.Modal(modalEl);
    modal.show();

    // 3. Set selected event id
    modalEl.querySelector('#select-evento option[data-event-id="' + eventId + '"]').selected = true;

}




var swiperDaypass = new Swiper(".swiper_daypass", {
    slidesPerView: 2,
    spaceBetween: 10,
    modules: [Navigation],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1024: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 'auto',
            slidesPerGroup: 2,
            spaceBetween: 10,
        },
        320: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 10,
        }
    }
});

var swiperAlojamientos = new Swiper(".swiper_alojamientos", {
      slidesPerView: 1,
      spaceBetween: 0,
      modules: [Navigation, Autoplay],
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".swiper-alojamientos-button-next",
        prevEl: ".swiper-alojamientos-button-prev",
      },
});
